import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-helium-bubble',
    templateUrl: './helium-bubble.component.html',
    styleUrls: ['./helium-bubble.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HeliumBubbleComponent {
  @Input() color: string;
  @Input() value: number;
}
